import React, { useState } from "react";
import { connect } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Select,
  OutlinedInput,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Button, DialogContentText,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { API_ROOT } from "../../../baseUrls";
import { Alert } from "@mui/material";

function ContactDialog({
  isOpen,
  closeDialog,
  user,
  mindfileId,
}) {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('normal');
  const canSend = () => status !== 'sending' && subject !== '' && message.trim() !== '';
  function send() {
    let formData = new FormData();
    formData.append("subject", subject);
    formData.append("message", message);

    setStatus('sending');
    fetch(`${API_ROOT}/mindfiles/${mindfileId}/contact`, {
      method: "POST",
      credentials: "include",
      body: formData,
      headers: {'X-CSRF-Token': user.authenticity_token},
    })
      .then(resp => {
        if (resp.ok) {
          setSubject('');
          setMessage('');
          setStatus('sent');
        } else {
          setStatus('error');
        }
      })
      .catch(error => {
        console.error(error);
        setStatus('error');
      });
  }

  let alert = null
  const closeAlert = () => setStatus("normal");
  if (status === 'sent') {
    alert = <Alert id="contactSent" severity="success" onClose={closeAlert}>Message sent.</Alert>
  } else if (status === 'error') {
    alert = <Alert  id="contactError" severity="error" onClose={closeAlert}>Message could not be sent.</Alert>
  }

  return (
    <Dialog open={isOpen} fullWidth maxWidth="md" PaperProps={{id:"contactDialog"}}>
      <DialogTitle id="contactTitle" onClose={closeDialog}>
        Contact
        <IconButton id="xCloseButton" onClick={closeDialog} style={{position:'absolute', right:8, top:8}}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please send us any feedback, your input is important to improving LifeNaut.<br/>
          Select the subject most appropriate and enter your message. This will be sent to the LifeNaut development team.
        </DialogContentText>
        {alert}
        <FormControl required variant="outlined" size="small" margin="normal" style={{ width: '100%' }}>
          <InputLabel>Subject</InputLabel>
          <Select
            id="contactSubject"
            value={subject}
            onChange={event => setSubject(event.target.value)}
            input={<OutlinedInput margin='dense' label="Subject" />}
          >
            <MenuItem value="report_a_bug">Report a bug</MenuItem>
            <MenuItem value="user_support">User support</MenuItem>
            <MenuItem value="question_or_comment">Question or comment</MenuItem>
            <MenuItem value="feature_request">Feature request</MenuItem>
            <MenuItem value="report_abuse">Report abuse</MenuItem>
            <MenuItem value="admin_request">Mindfile Administration Request</MenuItem>
            <MenuItem value="other">Other</MenuItem>
          </Select>
        </FormControl>
        <TextField
          required
          id="contactMessage"
          fullWidth
          variant="outlined"
          label="Message"
          multiline minRows={10}
          value={message}
          onChange={event => setMessage(event.target.value)}
          margin="normal"
          InputLabelProps={{shrink: true}}
        />
      </DialogContent>
      <DialogActions>
        <Button id="contactSend" color="primary" variant="contained" disabled={!canSend()} onClick={send}>
          Send
        </Button>
        <Button id="contactCancel" color="secondary" variant="contained" onClick={closeDialog}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const mapStateToProps = state => ({
  user: state.auth,
  mindfileId: state.mindfile.id,
});

export default connect(mapStateToProps)(ContactDialog);
